import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "yourTimezone", "start", "finish" ]

  connect() {
    this.yourTimezoneTarget.value = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // If there's no start time, assume we want the NOT AVAILABLE block to start now and last a day.
    if (this.startTarget.value === "") {
      var d = this.getCurrentTimeLocally();
      var formattedDate = this.toISODateString(d);
      this.startTarget.value = formattedDate;
      this.startTarget.dispatchEvent(new Event("change"));

      d.setDate(d.getDate() + 1);
      formattedDate = this.toISODateString(d);
      this.finishTarget.value = formattedDate;
      this.finishTarget.dispatchEvent(new Event("change"));
    }    
  }

  getCurrentTimeLocally() {
    var d = new Date();
    d.setTime(d.getTime() - (d.getTimezoneOffset() * 60 * 1000));
    return d;
  }

  toISODateString(d){
    function pad(n){return n<10 ? '0'+n : n}
    return d.getUTCFullYear()+'-'
    + pad(d.getUTCMonth()+1)+'-'
    + pad(d.getUTCDate())+'T'
    + pad(d.getUTCHours())+':'
    + pad(d.getUTCMinutes());
  }  
}
